import { css, keyframes } from "styled-components";

const PercentageBarAnim = (width: number) => keyframes`
  from {
    width: 0%;
  }
  to {
    width: ${width}%;
  }
`;

export const ProgressBarExpansion = (width: number) => css`
  width: 0%;

  animation-name: ${PercentageBarAnim(width)};
  animation-delay: 2s;
  animation-timing-function: ease-out;
  animation-play-state: running;
  animation-duration: var(--transition-speed-slow);
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  [data-is-loading="true"] & {
    animation-play-state: paused;
  }
`;
